import React, { useContext } from 'react'
import HeadingText from '../ActionCommonComponent/HeadingText'
import UserDisablePopupBody from '../../../Users/UserDisablePopupBody'
import InfoBox from '../../components/InfoBox'

import { useS3Data } from '../../../../hooks/useS3Data'

const DisableUser = ({data}) => {

    const { version_id, action, version_content, comment, new_content_snapshot } = data
    
    const { data: s3Data, loading } = useS3Data(new_content_snapshot)

    if (new_content_snapshot && loading) {
        return <p>Loading snapshot data...</p>
    }

    const displayContent = s3Data || version_content

    return (
        <>
            <HeadingText heading="Associated Version" text={version_id}/>
            <HeadingText heading="Activity" text={action}/>

            <HeadingText heading="Details (Read Only)">
                <InfoBox
                    redTitle={true}
                    heading={`User ${displayContent.disablingUser} will be Disabled`}
                    customeHeadWidth={"100%"}
                >
                    <UserDisablePopupBody
                        disableUserData={{
                            ...displayContent,
                            changeRequestComments: comment,
                        }}
                        showPassword={displayContent.is_password_included}
                        showSignature={displayContent.is_signature_included}
                        viewPurpose={true}
                    />
                </InfoBox>
            </HeadingText>
        </>
    )
}

export default DisableUser